import Firebase from 'firebase';
import firebase from 'firebase/app';
import 'firebase/database';


const config = {
    apiKey: "AIzaSyCzBSrGvrupGEcVj6nM_uwa2kDtDxWMjbw",
	authDomain: "oawebsite-b391e.firebaseapp.com",
	databaseURL: "https://oawebsite-b391e.firebaseio.com",
	projectId: "oawebsite-b391e",
	storageBucket: "oawebsite-b391e.appspot.com",
	messagingSenderId: "755248539958",
  };


const app = Firebase.initializeApp(config);
// let db = app.database();
const db = app.database();
export default db;
